import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  retailerFundedMarketingAdminCampaignBaseAccessControl,
  retailerFundedMarketingAdminCustomCampaignAccessControl,
} from '../access-control/retailerFundedMarketingAdminAccess.configuration'

const CampaignsListPageWithRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignsListPageWithRedirect" */
      '../pages/admin-campaigns/CampaignsListPageWithRedirect'
    )
)

const CampaignsTemplatesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignsTemplatesPage" */
      '../pages/admin-campaigns/CampaignsTemplatesPage'
    )
)

const CampaignsCreatePageWithRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignsCreatePageWithRedirect" */
      '../pages/admin-campaigns/CampaignsCreatePageWithRedirect'
    )
)

const CampaignsGetPageWithRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignsGetPageWithRedirect" */
      '../pages/admin-campaigns/CampaignsGetPageWithRedirect'
    )
)

const CampaignsEditPageWithRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "CampaignsEditPageWithRedirect" */
      '../pages/admin-campaigns/CampaignsEditPageWithRedirect'
    )
) as unknown as React.ComponentType<any>

const AdminCreateSegmentPage = lazy(() => import('../pages/admin-targeting/AdminCreateSegmentPage'))
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const campaignsAdminRouter = (
  <DomainRoute
    route="app-admin-campaigns"
    accessControl={retailerFundedMarketingAdminCampaignBaseAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-campaigns-list"
        component={CampaignsListPageWithRedirect}
      />
      <DomainRoute
        exact
        route="app-admin-campaigns-templates"
        component={CampaignsTemplatesPage}
        accessControl={retailerFundedMarketingAdminCustomCampaignAccessControl}
      />
      <DomainRoute
        exact
        route="app-admin-campaigns-create"
        component={CampaignsCreatePageWithRedirect}
      />
      {/* @ts-ignore TODO: Fix strict mode violations */}
      <DomainRoute exact route="app-admin-campaigns-get" component={CampaignsGetPageWithRedirect} />
      <DomainRoute
        exact
        route="app-admin-campaigns-edit"
        component={CampaignsEditPageWithRedirect}
      />
      <DomainRoute
        exact
        route="app-admin-create-segment"
        component={AdminCreateSegmentPage}
        accessControl={retailerFundedMarketingAdminCustomCampaignAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
